import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { ifDefined as l } from '../../../../../node_modules/lit-html/directives/if-defined.js';
import { setTextBlockClasses } from '../../accordion-item/layout/renderAccordionItem.js';
import { getRandomNumber } from '../../../utilities/math/index.js';
import { scrollIntoView } from '../../../utilities/behavior-helpers/index.js';
import { isRTL, isSafari } from '../../../utilities/dom-helpers/index.js';
import { unsafeHTML as o } from '../../../../../node_modules/lit-html/directives/unsafe-html.js';

const id = `acc-content-${getRandomNumber().toString(16).slice(2)}`;
// check if text block inside the accordion content has element with 'id' that equals to url hash
const isAnchorInsideContent = (node) => {
    const { hash } = document.location;
    if (!hash)
        return false;
    const content = node.querySelector('slot').assignedNodes()[0];
    const textBlock = content.querySelector('text-block');
    if (!textBlock)
        return false;
    return !!textBlock.querySelector(`[id='${hash.slice(1)}']`);
};
const renderImageAccordionItem = (ctx) => {
    setTimeout(() => {
        if (isAnchorInsideContent(ctx.renderRoot.querySelector('.content'))) {
            ctx.isExpanded = true;
            scrollIntoView(ctx.renderRoot.querySelector('.header'), document.querySelector('.container > .top'));
        }
        const content = ctx.renderRoot
            .querySelector('slot')
            .assignedNodes()[0];
        const textBlocks = content.querySelectorAll('text-block');
        setTextBlockClasses(textBlocks);
    }, 0);
    return x `<button class="header ${ctx.rtl || isRTL() ? 'rtl' : ''}" ?active="${ctx.isExpanded}" @click="${(e) => {
        ctx.handleClick(e);
        const target = e.currentTarget;
        target === null || target === void 0 ? void 0 : target.scrollIntoView();
        setTimeout(() => {
            if (isSafari)
                target === null || target === void 0 ? void 0 : target.scrollIntoView();
        }, 300);
    }}" @keyDown="${ctx.handleClick}" aria-expanded="${ctx.isExpanded ? 'true' : 'false'}" aria-controls="${id}"><img class="image" src="${l(ctx.image)}" alt="${l(ctx.imageAlt)}"><div class="text"><p class="title">${o(ctx.title)}</p><p class="subtitle">${o(ctx.subtitle)}</p></div><div class="icon"></div><hr></button><div class="content" id="${id}"><div class="inner"><slot name="image-accordion-content"></slot></div></div>`;
};

export { renderImageAccordionItem };
